var map = {
	"./PDF-Download_Icon": 432,
	"./PDF-Download_Icon.svg": 432,
	"./PDF-Icon-black": 433,
	"./PDF-Icon-black.svg": 433,
	"./PDF-Icon-red": 434,
	"./PDF-Icon-red.svg": 434,
	"./PDF-Icon-white": 435,
	"./PDF-Icon-white.svg": 435,
	"./Pfeil-Icon": 436,
	"./Pfeil-Icon.svg": 436,
	"./Pfeil-Kreis_Icon": 437,
	"./Pfeil-Kreis_Icon.svg": 437,
	"./TAFA-Kurs-Anmeldung_Button": 438,
	"./TAFA-Kurs-Anmeldung_Button.svg": 438,
	"./TAFA20-Webseite_FB_black": 439,
	"./TAFA20-Webseite_FB_black.svg": 439,
	"./TAFA20-Webseite_FB_red": 440,
	"./TAFA20-Webseite_FB_red.svg": 440,
	"./TAFA20-Webseite_IG_black": 441,
	"./TAFA20-Webseite_IG_black.svg": 441,
	"./TAFA20-Webseite_IG_red": 442,
	"./TAFA20-Webseite_IG_red.svg": 442,
	"./TAFA20-Webseite_Menu-icon_black": 443,
	"./TAFA20-Webseite_Menu-icon_black.svg": 443,
	"./TAFA20-Webseite_Menu-icon_red": 444,
	"./TAFA20-Webseite_Menu-icon_red.svg": 444,
	"./TAFA20-Webseite_PDF-Download_black": 445,
	"./TAFA20-Webseite_PDF-Download_black.svg": 445,
	"./TAFA20-Webseite_PDF-Download_red": 446,
	"./TAFA20-Webseite_PDF-Download_red.svg": 446,
	"./TAFA20-Webseite_PDF-Icon_black": 447,
	"./TAFA20-Webseite_PDF-Icon_black.svg": 447,
	"./TAFA20-Webseite_PDF-Icon_red": 448,
	"./TAFA20-Webseite_PDF-Icon_red.svg": 448,
	"./TAFA20-Webseite_Pfeil-Kreis_black": 449,
	"./TAFA20-Webseite_Pfeil-Kreis_black.svg": 449,
	"./TAFA20-Webseite_Pfeil-Kreis_red": 450,
	"./TAFA20-Webseite_Pfeil-Kreis_red.svg": 450,
	"./TAFA20-Webseite_Pfeil-down_black": 451,
	"./TAFA20-Webseite_Pfeil-down_black.svg": 451,
	"./TAFA20-Webseite_Pfeil-links_black": 452,
	"./TAFA20-Webseite_Pfeil-links_black.svg": 452,
	"./TAFA20-Webseite_Pfeil-links_dropshadow_black": 453,
	"./TAFA20-Webseite_Pfeil-links_dropshadow_black.svg": 453,
	"./TAFA20-Webseite_Pfeil-links_red": 454,
	"./TAFA20-Webseite_Pfeil-links_red.svg": 454,
	"./TAFA20-Webseite_Pfeil-oben_black": 455,
	"./TAFA20-Webseite_Pfeil-oben_black.svg": 455,
	"./TAFA20-Webseite_Pfeil-oben_red": 456,
	"./TAFA20-Webseite_Pfeil-oben_red.svg": 456,
	"./TAFA20-Webseite_Pfeil-rechts_black": 457,
	"./TAFA20-Webseite_Pfeil-rechts_black.svg": 457,
	"./TAFA20-Webseite_Pfeil-rechts_dropshadow_black": 458,
	"./TAFA20-Webseite_Pfeil-rechts_dropshadow_black.svg": 458,
	"./TAFA20-Webseite_Pfeil-rechts_red": 459,
	"./TAFA20-Webseite_Pfeil-rechts_red.svg": 459,
	"./TAFA20-Webseite_Pfeil-unten_red": 460,
	"./TAFA20-Webseite_Pfeil-unten_red.svg": 460,
	"./TAFA20-Webseite_Pfeil-unten_white": 461,
	"./TAFA20-Webseite_Pfeil-unten_white.svg": 461,
	"./TAFA20-Webseite_Ticket_black": 462,
	"./TAFA20-Webseite_Ticket_black.svg": 462,
	"./TAFA20-Webseite_Ticket_red": 463,
	"./TAFA20-Webseite_Ticket_red.svg": 463,
	"./TAFA20-Webseite_VIMEO-rechts_black": 464,
	"./TAFA20-Webseite_VIMEO-rechts_black.svg": 464,
	"./TAFA20-Webseite_VIMEO_red": 465,
	"./TAFA20-Webseite_VIMEO_red.svg": 465,
	"./TAFA20-Webseite_dropdown_black": 466,
	"./TAFA20-Webseite_dropdown_black.svg": 466,
	"./TAFA20-Webseite_dropdown_red": 467,
	"./TAFA20-Webseite_dropdown_red.svg": 467,
	"./TAFA20-Webseite_x_black": 468,
	"./TAFA20-Webseite_x_black.svg": 468,
	"./TAFA20-Webseite_x_red": 469,
	"./TAFA20-Webseite_x_red.svg": 469,
	"./Tanzfabrik_Signet-black": 470,
	"./Tanzfabrik_Signet-black.svg": 470,
	"./Tanzfabrik_Signet-green": 471,
	"./Tanzfabrik_Signet-green.svg": 471,
	"./Tanzfabrik_Signet-red": 472,
	"./Tanzfabrik_Signet-red.svg": 472,
	"./Tanzfabrik_Signet-white": 473,
	"./Tanzfabrik_Signet-white.svg": 473,
	"./Ticket-Icon": 474,
	"./Ticket-Icon.svg": 474,
	"./booking-calendar": 54,
	"./booking-calendar.svg": 54,
	"./studio-map-marker": 55,
	"./studio-map-marker.svg": 55
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 718;